import React from 'react'

export const fontList = []

/*

Note: cannot currently import JSX component because of this Helmet warning:

"You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information."

*/

const Fonts = () => {
    return <></>
}

export default Fonts
